import type { iconName } from "@/Modules/App/Models/Styles/Icons";

export enum AgentItemType {
  ANSWER = "answer",
  ASK = "ask",
}

export enum AgentStage {
  LOADING = "loading",
  WRITING = "writing",
}

export interface SuggestionItem {
  icon: iconName;
  title: string;
  prompt: string;
}

export interface ConversationItem {
  uuid: string;
  avatar: string | null;
  username: string;
  customerUuid: string;
  isAgent: boolean;
}

export interface AgentItem {
  uuid: string;
  type: AgentItemType.ANSWER | AgentItemType.ASK;
  question: string;
  answer: string;
  createdAt: number;
  updatedAt: number;
  ragSessionUuid: string;
  info?: string;
  isRecent: boolean;
}
